import { getSkip } from "common/skipper";
// import log from "loglevel";
/**
 * skip이 가능한 delay
 * 컨텐츠를 스킵하고 싶을 때 delay를 skip해야 한다면 이 함수를
 * 사용해야 한다.
 */
export async function delay(millis) {
    if (getSkip().skipDelay) {
        // log.trace("delay skipped");
        return new Promise((resolve) => {
            setTimeout(resolve, millis / 10);
        });
    }
    else {
        // log.trace(`delay for ${millis}`);
    }
    return new Promise((resolve) => {
        setTimeout(resolve, millis);
    });
}
export async function delaySound(millis) {
    // log.trace(`delay Sound for ${millis}`);
    return new Promise((resolve) => {
        setTimeout(resolve, millis);
    });
}
/**
 * 애니메이션에서 사용하는 딜레이로 skip의 대상이 되지 않는다.
 * 애니메이션의 종료 조건이 delay와 관련 없을 때 사용해야 한다.
 */
export async function delayAnimation(millis) {
    return new Promise((resolve) => {
        setTimeout(resolve, millis);
    });
}
//# sourceMappingURL=delay.js.map